import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import dayjs from "dayjs";
import useTranslation from "utils/hooks/useTranslation";
import { usePopover } from "providers/PopoverProvider";
import Table from "components/shared/list/table";
import { getSolutionNomDeProposition } from "components/EtudeForm/Solutions/SolutionDetails/helpers";
import Button from "components/shared/button";
import ContextMenuList from "components/ContextMenu/ContextMenuList";
import { usePopup } from "providers/PopupProvider";
import { DeletePopup } from "components/popups/DeletePopup";
import { useNavigate } from "react-router";
import { getAppUrl } from "utils/defines";
import { EtudeStep } from "utils/defines";
import { MailPopup } from "components/popups/MailPopup";
import Select from "components/shared/inputs/select";
import { SavePopup } from "components/popups/SavePopup";
import Loader from "components/shared/loader";
import { removeLocalStorageTraceId } from "utils/helpers/localStorage";
import { PdfDownloadPopup } from "components/popups/PdfDownloadPopup";
import { SvgCommandDuplicate } from "components/svg";
import { useDuplicateEtudeMutation } from "store/api";

export const MyEtudesTable: React.FC<{
  etudesListData: any;
  setEtudesListData: any;
  setSelectedRowsCount: any;
  setSelectedRowIDs: any;
  currentSelectedRowSteps: any;
  network: any;
  refetchEtudeListData: any;
  etudesTotal: any;
  currentPage: any;
  setCurrentPage: any;
  pageSize: any;
}> = ({
  etudesListData,
  setEtudesListData,
  setSelectedRowsCount,
  setSelectedRowIDs,
  currentSelectedRowSteps,
  // setSelectedRowEtudePaths,
  network,
  refetchEtudeListData,
  etudesTotal,
  currentPage,
  setCurrentPage,
  pageSize,
}) => {
    const { t, language } = useTranslation();
    const { openPopup, closeLastPopup } = usePopup();
    const navigate = useNavigate();

    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const currentSelectedRowID = useRef<number[]>([]);
    const currentSelectedRowService = useRef<string>("");
    const currentSelectedRowSolutionID = useRef<string>("");
    const [currentSelectedRowStep, setCurrentSelectedRowStep] =
      useState<number>(0);
    const [savedEvent, setSavedEvent] = useState<React.MouseEvent | null>(null);
    const currentSelectedTPID = useRef<number | null>(null);
    const [isPdfURLLoading, setIsPdfURLLoading] = useState<boolean>(false);
    const [selectedVersions, setSelectedVersions] = useState(
      etudesListData.reduce((acc: any, row: any) => {
        acc[row.id] = row.version;

        return acc;
      }, {})
    );
    const savedRowNameRef = useRef<string>("");
    const [duplicateEtudeMutation] = useDuplicateEtudeMutation();

    const getEtudePath = (
      etudeType?: string,
      etudeId?: number,
      solutionDetailID?: string,
      step?: number
    ) => {
      const type = etudeType ?? currentSelectedRowService.current;
      const id = etudeId ?? currentSelectedRowID.current[0];
      const solID = encodeURIComponent(
        solutionDetailID ?? currentSelectedRowSolutionID.current
      );
      const st = step ?? currentSelectedRowStep;

      switch (st) {
        case EtudeStep.InputForm:
          return `/etude/${type}/${id}`;
        case EtudeStep.Solutions:
          return `/etude/${type}/${id}/solutions`;
        case EtudeStep.SolutionDetails:
          return `/etude/${type}/${id}/solutions/${solID}`;
        case EtudeStep.Accessoires:
          return `/etude/${type}/${id}/solutions/${solID}/accessoires`;
        case EtudeStep.Documents:
          return `/etude/${type}/${id}/documents`;
        default:
          return `/etude/${type}/${id}`;
      }
    };

    const onSelectChange = (
      newSelectedRowKeys: React.Key[],
      selectedRows: any
    ) => {
      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRowIDs(selectedRows.map((row: any) => row.id));

      /*const updatedPaths = selectedRows.map((row: any) => {
          const versions = JSON.parse(row.versions).reverse();
          const selVersion = versions.find((v: any) => v.ID == row.id);
          const version = JSON.parse(selVersion?.json);
    
          currentSelectedRowID.current = [row.id!];
          currentSelectedRowService.current = row.service;
          currentSelectedRowSolutionID.current = version.selectedSolutionID;
          setCurrentSelectedRowStep(version.step;
    
          return getEtudePath();
        });
    
        setSelectedRowEtudePaths(updatedPaths);*/

      const selectedRowSteps = selectedRows.map((row: any) => {
        const versions = JSON.parse(row.versions).reverse();
        const selVersion = versions.find((v: any) => v.ID == row.id);
        const version = JSON.parse(selVersion?.json);

        return version.step;
      });

      currentSelectedRowSteps.current = selectedRowSteps;
    };

    const rowSelection: any = {
      selectedRowKeys,
      onChange: onSelectChange,
    };

    useEffect(() => {
      setSelectedRowsCount(selectedRowKeys.length);
    }, [selectedRowKeys, setSelectedRowsCount]);

    useEffect(() => {
      setEtudesListData(etudesListData);
    }, [setEtudesListData, etudesListData]);

    const onVersionChange = (value: any, data: any) => {
      const versions = JSON.parse(data.versions);
      const index = value[value.length - 1];

      const version = versions.find((v: any) => v.version == index);

      const updatedData = etudesListData.map((row: any) => {
        let updatedRow;

        if (row.thercodim_projectId == version.thercodim_projectId) {
          updatedRow = {
            ...row,
            ...version,
            id: version.ID,
          };

          setSelectedVersions((prev: any) => ({
            ...prev,
            [version.ID]: version.version,
          }));
        } else {
          updatedRow = row;
        }

        return updatedRow;
      });

      setEtudesListData(updatedData);
    };

    const onMoreOpenClick = useCallback(() => {
      const path = getEtudePath();

      navigate(getAppUrl(path, { network: network?.code }));
    }, [getEtudePath, navigate, network]);

    const onMoreSendClick = useCallback(() => {
      // const path = getAppUrl(getEtudePath(), { network: network?.code });

      openPopup(
        <MailPopup
          etudeIds={JSON.stringify(currentSelectedRowID.current)}
          showPrice={false}
          isEtudeDetail={false}
          culture={language!}
          networkId={network?.id}
        // etudeURL={path}
        />
      );
    }, [openPopup, language, network]);

    const onMoreDownloadClick = useCallback(() => {

      openPopup(
        <PdfDownloadPopup
          network={network}
          selectedRowIDs={currentSelectedRowID.current}
          isPdfURLLoading={isPdfURLLoading}
          setIsPdfURLLoading={setIsPdfURLLoading}
        />
      );
    }, [network, isPdfURLLoading, setIsPdfURLLoading]);

    const onMoreEditClick = useCallback(() => {
      openPopup(
        <SavePopup
          closePopup={closeLastPopup}
          isRenaming
          renamingEtudeId={currentSelectedTPID.current}
          currentName={savedRowNameRef.current}
          refetchEtudeListData={refetchEtudeListData}
        />
      );
    }, [openPopup, closeLastPopup, refetchEtudeListData]);

    const onMoreDeleteClick = useCallback(() => {
      openPopup(
        <DeletePopup
          closePopup={closeLastPopup}
          network={network}
          selectedRowIDs={currentSelectedRowID.current}
          etudesListData={etudesListData}
          setEtudesListDataCallback={setEtudesListData}
          refetchEtudeListData={refetchEtudeListData}
        />
      );
    }, [
      openPopup,
      closeLastPopup,
      network,
      etudesListData,
      setEtudesListData,
      refetchEtudeListData,
    ]);

    const onMoreDuplicateClick = useCallback(() => {
      duplicateEtudeMutation({ etudeVersionId: currentSelectedRowID.current[0] }).then((result: any) => {
        const newEtudeId = result?.data;
        if (newEtudeId.id || newEtudeId.ID) {
          const newId = newEtudeId.id || newEtudeId.ID;
          const path = getEtudePath(currentSelectedRowService.current, newId);
          navigate(getAppUrl(path, { network: network?.code }));
        } else {
          refetchEtudeListData();
        }
      });
    }, [duplicateEtudeMutation, getEtudePath, navigate, network, refetchEtudeListData]);

    const moreMenuItems = useMemo(
      () => [
        {
          text: t("FO_SIM_OPEN"),
          icon: "open_in_new",
          onClick() {
            removeLocalStorageTraceId();
            onMoreOpenClick();
          },
        },
        {
          text: t("upload"),
          icon: "save",
          hide:
            selectedRowKeys.length >= 2 ||
            currentSelectedRowStep < EtudeStep.Documents,
          onClick() {
            onMoreDownloadClick();
          },
        },
        {
          text: t("FO_STUDIES_RENAME"),
          icon: "edit",
          onClick() {
            onMoreEditClick();
          },
        },
        {
          text: t("FO_STUDIES_SEND"),
          icon: "mail",
          hide:
            selectedRowKeys.length >= 2 ||
            currentSelectedRowStep < EtudeStep.Documents,
          onClick() {
            onMoreSendClick();
          },
        },
        {
          text: t("FO_STUDIES_DUPLICATE"),
          icon: <icon data-svg-size="16"><SvgCommandDuplicate /></icon>,
          onClick() {
            onMoreDuplicateClick();
          },
        },
        { separator: true },
        {
          text: t("FO_STUDIES_DELETE"),
          icon: "delete",
          onClick() {
            onMoreDeleteClick();
          },
        },
      ],
      [
        t,
        selectedRowKeys.length,
        currentSelectedRowStep,
        onMoreOpenClick,
        onMoreDownloadClick,
        onMoreEditClick,
        onMoreSendClick,
        onMoreDuplicateClick,
        onMoreDeleteClick,
      ]
    );

    const { open } = usePopover();
    const onMoreClick = useCallback(
      (e: React.MouseEvent) => {
        open({
          element: (e.target as any).closest("[data-popover-trigger]"),
          content: <ContextMenuList data-space="5" items={moreMenuItems} />,
        });
      },
      [open, moreMenuItems]
    );

    useEffect(() => {
      if (savedEvent) {
        onMoreClick(savedEvent);
        setSavedEvent(null);
      }
    }, [savedEvent, currentSelectedRowStep, moreMenuItems, onMoreClick]);

    const handleRowOpen = (data: GetEtudeResponse) => {
      const versions = JSON.parse(data.versions).reverse();
      const selVersion = versions.find((v: any) => v.ID == data.id);
      const version = JSON.parse(selVersion?.json);

      currentSelectedRowID.current = [data.id!];
      currentSelectedRowService.current = data.service;
      currentSelectedRowSolutionID.current = version.selectedSolutionID;
      setCurrentSelectedRowStep(version.step);

      const path = getEtudePath(
        data.service,
        data.id!,
        version.selectedSolutionID,
        version.step
      );
      navigate(getAppUrl(path, { network: network?.code }));
    };

    const columns = [
      {
        width: 100,
        title: t("FO_DOC_VERSION"),
        dataIndex: "version",
        key: "version",
        render: (_: any, data: GetEtudeResponse) => {
          const versions = JSON.parse(data.versions);

          return (
            <Select
              name="dropdown"
              dataLength="100"
              defaultValue={"V" + data.version}
              options={versions.map((version: any) => {
                if (!versions[0].json) return;
                const selectedVersion = JSON.parse(version.json);
                let nomDeProposition = t("FO_STUDIES_IN_PROGRESS");
                let isOnLastStep: boolean = false;

                if (
                  EtudeStep.Documents == selectedVersion.step &&
                  selectedVersion.selectedSolution
                ) {
                  nomDeProposition = getSolutionNomDeProposition(
                    selectedVersion.selectedSolution
                  );
                  isOnLastStep = true;
                }

                return {
                  value: "V" + version.version,
                  text: "V" + version.version,
                  data: {
                    ...version,
                    nomDeProposition,
                    isOnLastStep: isOnLastStep,
                  },
                };
              })}
              optionRender={(option: any) => (
                <group
                  key={option.data.key}
                  data-length="autofit"
                  data-align="center"
                  data-space="10"
                  data-gap="20"
                  data-justify="center"
                >
                  <group data-length="20">{option.text}</group>
                  <separator data-vertical=""></separator>
                  <group data-length="autofit">
                    <text data-text-size="14">
                      {dayjs(
                        option.data.createdAt || option.data.updatedAt
                      ).format("DD/MM/YYYY")}
                    </text>
                  </group>
                  <group data-length="autofit">
                    <text data-text-size="12" data-opacity="50">
                      {dayjs(
                        option.data.createdAt || option.data.updatedAt
                      ).format("hh:mm")}{" "}
                    </text>
                  </group>
                  <group
                    data-length="100"
                    {...(option.data.isOnLastStep
                      ? {
                        "data-name": "success-badges",
                        "data-custom-badges": "",
                        "data-color": "success-color",
                        "data-background": "success-color-light",
                      }
                      : {
                        "data-name": "warning-badges",
                        "data-custom-badges": "",
                        "data-color": "warning",
                        "data-background": "warning-light",
                      })}
                    data-border=""
                    data-radius="4"
                    data-space="5"
                    data-justify="center"
                    data-align="center"
                    data-text-align="center"
                  >
                    <text data-color="grey-color-dark" data-ellipsis="" data-wrap="wrap">
                      {option.data.nomDeProposition}
                    </text>
                  </group>
                  <group data-length="autofit">
                    <Button
                      micro
                      rounded
                      icon="delete"
                      onClick={() => {
                        currentSelectedRowID.current = [option.data.ID];

                        onMoreDeleteClick();
                      }}
                    />
                  </group>
                </group>
              )}
              popupMatchSelectWidth={false}
              onChange={(value) => onVersionChange(value, data)}
            />
          );
        },
      },
      {
        width: 150,
        title: t("RAPP_REF"),
        dataIndex: "reference",
        key: "reference",
        sorter: (a: GetEtudeResponse, b: GetEtudeResponse) =>
          a.reference && b.reference && a.reference.localeCompare(b.reference),
        render: (text: string, data: GetEtudeResponse) => (
          <group
            onClick={() => handleRowOpen(data)}
            data-height="fit"
            data-align="center"
            data-cursor="pointer"
          >
            <text
              data-text-size="14"
              data-color="grey-color-dark"
              data-wrap="wrap"
              data-ellipsis=""
            >
              {text}
            </text>
          </group>
        ),
      },
      {
        width: 150,
        title: t("FO_STUDIES_STUDY_NAME"),
        dataIndex: "siteName",
        key: "siteName",
        sorter: (a: GetEtudeResponse, b: GetEtudeResponse) =>
          a.siteName && b.siteName && a.siteName.localeCompare(b.siteName),
        render: (text: string, data: GetEtudeResponse) => (
          <group
            onClick={() => handleRowOpen(data)}
            data-height="fit"
            data-align="center"
            data-cursor="pointer"
          >
            <text
              data-text-size="14"
              data-weight="600"
              data-invert=""
              data-wrap="wrap"
              data-ellipsis=""
            >
              {text}
            </text>
          </group>
        ),
      },
      {
        width: 170,
        title: t("FO_STUDIES_CLIENT_NAME"),
        dataIndex: "clientName",
        key: "clientName",
        sorter: (a: GetEtudeResponse, b: GetEtudeResponse) =>
          a.clientName &&
          b.clientName &&
          a.clientName.localeCompare(b.clientName),
        render: (text: string, data: GetEtudeResponse) => (
          <group
            onClick={() => handleRowOpen(data)}
            data-height="fit"
            data-align="center"
            data-cursor="pointer"
          >
            <text
              data-text-size="14"
              data-weight="600"
              data-wrap="wrap"
              data-ellipsis=""
            >
              {text}
            </text>
          </group>
        ),
      },
      {
        width: 130,
        title: t("FO_STUDIES_CREATED"),
        dataIndex: "createdAtOrUpdatedAt",
        key: "createdAtOrUpdatedAt",
        sorter: (a: GetEtudeResponse, b: GetEtudeResponse) => {
          if (!a.updatedAt) return 1;
          if (!b.updatedAt) return -1;
          return (
            new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime()
          );
        },
        render: (_: any, data: GetEtudeResponse) => {
          const versions = JSON.parse(data.versions);
          const index = selectedVersions[data.id!];

          const version = index
            ? versions.find((v: any) => v.version == index)
            : versions[versions.length - 1];

          return (
            <group
              onClick={() => handleRowOpen(data)}
              data-height="fit"
              data-cursor="pointer"
              data-direction="column"
            >
              <text data-text-size="14">
                {dayjs(version.updatedAt || version.createdAt).format(
                  "DD/MM/YYYY"
                )}
              </text>
              <text data-text-size="12" data-opacity="50">
                {dayjs(version.updatedAt || version.createdAt).format("hh:mm")}
              </text>
            </group>
          );
        },
      },
      {
        width: 130,
        title: t("FO_STUDIES_PLACE"),
        dataIndex: "siteCityOrSiteCP",
        key: "siteCityOrSiteCP",
        sorter: (a: GetEtudeResponse, b: GetEtudeResponse) =>
          a.siteCity && b.siteCity && a.siteCity.localeCompare(b.siteCity),
        render: (_: any, data: GetEtudeResponse) => (
          <group
            onClick={() => handleRowOpen(data)}
            data-height="fit"
            data-cursor="pointer"
            data-direction="column"
          >
            <text data-text-size="14" data-wrap="wrap" data-ellipsis="">
              {data.siteCity}
            </text>
            <text
              data-text-size="12"
              data-opacity="50"
              data-wrap="wrap"
              data-ellipsis=""
            >
              {data.siteCP}
            </text>
          </group>
        ),
      },
      {
        width: 130,
        title: t("FO_STUDIES_TYPE"),
        dataIndex: "service",
        key: "service",
        sorter: (a: GetEtudeResponse, b: GetEtudeResponse) =>
          a.service && b.service && a.service.localeCompare(b.service),
        render: (text: string, data: GetEtudeResponse) => (
          <group
            onClick={() => handleRowOpen(data)}
            data-height="fit"
            data-cursor="pointer"
            data-ellipsis=""
          >
            <text data-text-size="14">{text}</text>
          </group>
        ),
      },
      {
        width: 220,
        title: t("FO_STUDIES_SOLUTION"),
        dataIndex: "solution",
        key: "solution",
        render: (_: any, data: GetEtudeResponse) => {
          const versions = JSON.parse(data.versions);
          const index = selectedVersions[data.id!];
          if (!versions[0].json) return;

          const version = JSON.parse(
            (index
              ? versions.find(
                (v: any) => v.version == index || v.version == index - 1
              )
              : versions[versions.length - 1]
            ).json
          );

          const step = version.step;
          const selectedSolution = version?.selectedSolution;
          let nomDeProposition = t("FO_STUDIES_IN_PROGRESS");
          let isOnLastStep: boolean = false;

          if (EtudeStep.Documents == step && selectedSolution) {
            nomDeProposition = getSolutionNomDeProposition(selectedSolution);
            isOnLastStep = true;
          }

          return (
            <group
              data-length="330"
              {...(isOnLastStep
                ? {
                  "data-name": "success-badges",
                  "data-custom-badges": "",
                  "data-color": "success-color",
                  "data-background": "success-color-light",
                }
                : {
                  "data-name": "warning-badges",
                  "data-custom-badges": "",
                  "data-color": "warning",
                  "data-background": "warning-light",
                })}
              data-border=""
              data-radius="4"
              data-space="5"
              data-justify="center"
              onClick={() => handleRowOpen(data)}
              data-cursor="pointer"
              data-text-align="center"
            >
              <text data-color="grey-color-dark" data-wrap="wrap" data-align="center">
                {nomDeProposition}
              </text>
            </group>
          );
        },
      },
      {
        title: "",
        dataIndex: "action",
        key: "action",
        width: 50,
        render: (_: number, data: GetEtudeResponse) => (
          <group data-popover-trigger data-custom="">
            <Button
              micro
              rounded
              icon="more_horiz"
              onClick={(e: any) => {
                const versions = JSON.parse(data.versions).reverse();
                const selVersion = versions.find((v: any) => v.ID == data.id);
                const version = JSON.parse(selVersion?.json);
                const etude = etudesListData.find(
                  (row: any) => row.id === data.id
                );
                currentSelectedRowID.current = [data.id!];
                currentSelectedRowService.current = data.service;
                currentSelectedRowSolutionID.current = version.selectedSolutionID;
                currentSelectedTPID.current = data.thercodim_projectId as any;
                savedRowNameRef.current = etude.siteName;
                setCurrentSelectedRowStep(version.step);
                setSavedEvent(e);
              }}
            />
          </group>
        ),
      },
    ];

    const handleTableChange = (pagination: any) => {
      setCurrentPage(pagination.current);
    };

    return (
      <group
        data-border=""
        data-radius="10"
        data-contain=""
        data-name="custom_grid"
      >
        {isPdfURLLoading && <Loader />}
        <Table
          style={{ width: "100%" }}
          columns={columns}
          dataSource={etudesListData}
          rowSelection={rowSelection}
          pagination={{
            current: currentPage,
            total: etudesTotal,
            pageSize,
            showSizeChanger: false,
          }}
          onChange={handleTableChange}
          rowKey={(etude) => etude.id}
          scroll={{
            y: 610,
          }}
        />
      </group>
    );
  };
